module.exports = __webpack_public_path__ + "static/d1-0bde0f280b8c5a4ddfd4eb92fd05da48.jpg";